import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import qs from 'qs';

export const baseURL = process.env.REACT_APP_API_URL;

export const Api = (
  headers: any = {},
  timeout?: number,
  responseType?: AxiosRequestConfig['responseType'],
): AxiosInstance => {
  const instance = axios.create({
    baseURL,
    // qs serialize array to Spring default format: a[0].b=x&a[0].c=y ...
    paramsSerializer: (params) => qs.stringify(params, { allowDots: true }),
    timeout: timeout || 0, // 0 means no timeout
    headers: {
      // Authorization: "Bearer " + Auth().getToken(),
      'Access-Control-Allow-Origin': process.env.REACT_APP_API_URL,
      ...headers,
    },
    responseType: responseType,
    maxRedirects: 0,
    validateStatus(status) {
      return status >= 200 && status < 303; // 300
    },
  });

  instance.interceptors.request.use(
    (request) => request,
    (error) => errorInterceptor(error, 'Request'),
  );

  instance.interceptors.response.use(
    (response) => response,
    (error) => errorInterceptor(error, 'Response'),
  );

  return instance;
};

const errorInterceptor = (error: any, source: string) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(`[axios Interceptor] ${source} Error:`);
    console.error(error);
  }

  return Promise.reject(error);
};
